import React from "react";

export const renderToolbarBasic = (Toolbar) => (
  <Toolbar>
    {(slots) => {
      const {
        CurrentPageInput,
        GoToNextPage,
        GoToPreviousPage,
        NumberOfPages,
        ShowSearchPopover,
        Zoom,
        ZoomIn,
        ZoomOut,
      } = slots;
      return (
        <div className={"rpv-toolbar"}>
          <div className={"rpv-toolbar__left"} style={{ minWidth: "25%" }}>
            <div className={"rpv-toolbar__item"}>
              <ShowSearchPopover />
            </div>
            <div className={"rpv-core__display--hidden rpv-core__display--block-small"}>
              <div className={"rpv-toolbar__item"}>
                <GoToPreviousPage />
              </div>
            </div>
            <div className={"rpv-toolbar__item"}>
              <CurrentPageInput />
              / <NumberOfPages />
            </div>
            <div className={"rpv-core__display--hidden rpv-core__display--block-small"}>
              <div className={"rpv-toolbar__item"}>
                <GoToNextPage />
              </div>
            </div>
          </div>
          <div className={"rpv-toolbar__center"} style={{ minWidth: "50%" }}>
            <div className={"rpv-toolbar__item"}>
              <ZoomOut />
            </div>
            <div className={"rpv-core__display--hidden rpv-core__display--block-small"}>
              <div className={"rpv-toolbar__item"}>
                <Zoom />
              </div>
            </div>
            <div className={"rpv-toolbar__item"}>
              <ZoomIn />
            </div>
          </div>
          <div className={"rpv-toolbar__right"} style={{ minWidth: "25%" }}></div>
        </div>
      );
    }}
  </Toolbar>
);
